import PageMeta from "../../components/common/PageMeta";
import {
    API_BASE_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
    DEFAULT_PER_PAGE,
} from "../../utilities/constants";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { useEffect, useState } from "react";
import { handleApiCall } from "../../utilities/helper";
import Tabs from "../../components/ui/Tabs"
import LeaderCard from "./LeaderCards";
import { useLocation } from "react-router";
import { FaCrown, FaUserPlus } from "react-icons/fa";
import LeaderBoardCard from "./LeaderBoardCard";
import Pagination from "../../components/ui/Pagination";
import useQueryParams from "../../hooks/useQueryParams";

const LeadershipBoard = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [referral, setReferral] = useState(null);
    const [controller, setController] = useState(null);
    const location = useLocation();
    const { queryParams } = useQueryParams();
    const tab = queryParams.get("tab") || "Stylist";
    const pageNo = queryParams.get("page") || 0;
    const pageSize = queryParams.get("pageSize") || 12;
    const sortOrder = queryParams.get("sortOrder") || "DESC";

    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {

            const response = await handleApiCall(
                `${API_BASE_URL}/api/backoffice/insidercircle/leaderboard?metric=stylists&`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        callListApi();
    }, []);

    const callReferralListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {

            const response = await handleApiCall(
                `${API_BASE_URL}/api/backoffice/insidercircle/insiders?page=${pageNo}&size=${pageSize}&sortBy=createdAt&direction=${sortOrder}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setReferral(response.data);
            } else {
                setReferral(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        callReferralListApi();
    }, [location.search]);

    // console.log("DATAA#####", data)
    // console.log("referral????????????", referral)


    return (
        <>
            <PageMeta
                title={`Leader Board - ${DEFAULT_PAGE_TITLE}`}
                description={`Leader Board - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <PageBreadcrumb pageTitle="Leader Board" />
            <Tabs
                tabs={[
                    {
                        label: "Stylist",
                        content: (
                            <div>
                                <div className="flex items-center gap-2 mb-4">
                                    <FaCrown className="w-5 h-5 text-[#CA8A04]" />
                                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                                        Stylists
                                    </h3>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
                                    {data?.map((stylist) => (
                                        <LeaderBoardCard key={stylist.stylistId} stylist={stylist} />
                                    ))}
                                </div>

                            </div>
                        ),
                    },
                    {
                        label: "Referral",
                        content: (
                            <div>
                                <div className="flex items-center gap-2 mb-4">
                                    <FaUserPlus className={`w-5 h-5 text-[#CA8A04]`} />
                                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                                        Referral
                                    </h3>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
                                    {referral?.data?.map((referral) => (
                                        <LeaderBoardCard key={referral.id} referral={referral} />

                                    ))}
                                    <div className='fle justify-center items-center self-center'>
                                        <Pagination
                                            pageParam="page"
                                            currentPage={referral?.pageNumber + 1} 
                                            totalElements={referral?.totalElements}
                                        />
                                    </div>
                                </div>
                            </div>
                        ),
                    },
                ]}
            />

        </>
    );
};

export default LeadershipBoard;
